import { memo } from "react";

import { Typography } from "neetoui";

const TimeItem = ({ value, suffix }) => (
  <div className="flex items-end" data-testid="time-item">
    <Typography className="me-1" style="h1" weight="semibold">
      {value}
    </Typography>
    <Typography lineHeight="loose" style="body2">
      {suffix}
    </Typography>
  </div>
);

export default memo(TimeItem);
